/**
 * Bundled SCDF Fire Code 2023 chapter dataset.
 *
 * Each JSON file conforms to ../workflow.schema.json. Importing JSON works
 * out-of-the-box in Vite, Next.js, Create-React-App and Readdy.ai builds.
 *
 * `chapters` is sorted by chapter number so the side-nav order is stable.
 */
import chapter01 from "./chapter01.json";
import chapter02 from "./chapter02.json";
import chapter03 from "./chapter03.json";
import chapter04 from "./chapter04.json";
import chapter05 from "./chapter05.json";
import chapter06 from "./chapter06.json";
import chapter07 from "./chapter07.json";
import chapter08 from "./chapter08.json";
import chapter09 from "./chapter09.json";
import chapter10 from "./chapter10.json";
import chapter11 from "./chapter11.json";

export const chapters = [
  chapter01,
  chapter02,
  chapter03,
  chapter04,
  chapter05,
  chapter06,
  chapter07,
  chapter08,
  chapter09,
  chapter10,
  chapter11,
].sort((a, b) => a.chapter - b.chapter);

export default chapters;
